import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { Alert, Button, Card, Form, Input } from "antd"
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createRoleWithPermissions, getPermissions, getRolePermissionById, updateRoleWithPermissions } from "../../store/slices/roleSlice";
import Checkbox from "antd/es/checkbox/Checkbox";
import { useParams } from "react-router-dom";
import { createSocket } from "./socket"; // adjust path
// import io from 'socket.io-client';
// const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000/api"
// const socket = io(baseUrl.replace('/api', ''));

const EditRole = () => {
    const socketRef = useRef(null);
    const { id } = useParams();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [buttonLoading, setButtonLoading] = useState(false);
    const [checkedList, setCheckedList] = useState([]);
    const user = useSelector((state) => state?.auth?.after_login_data?.data)
    useEffect(() => {
        dispatch(getRolePermissionById(id))
        dispatch(getPermissions())
    }, [dispatch, id])
    useEffect(() => {
        if (!user?._id) return;

        socketRef.current = createSocket(user._id);

        socketRef.current.on("role updated", (data) => {
            console.log("Role updated received:", data);

            // If this user's role matches → update UI
            // if (user?.role?._id === data.roleId) {
            //     setCheckedList(data.permissions);
            //     form.setFieldsValue({ permissionIds: data.permissions });
            // }
        });

        return () => {
            if (socketRef.current) {
                socketRef.current.off("role updated");
                socketRef.current.disconnect();
            }
        };
    }, [user?._id]);
    const { rolePermission, permissions } = useSelector((state) => state.role);
    const options = permissions?.data?.map((data) => ({
        label : data?.name
                .split("_")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" "),
        value : data?._id
    }))
    const groupedPermissions = permissions?.data?.reduce((acc, perm) => {
        const type = perm.type || "other";

        if (!acc[type]) {
            acc[type] = [];
        }

        acc[type].push({
            label: perm.name
                .split("_")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" "),
            value: perm._id
        });

        return acc;
    }, {});
    // const defaultOptions = rolePermission?.data?.permissions?.map((item) => item?._id) || [];
    useEffect(() => {
        if (rolePermission?.data) {
            const defaultValues = rolePermission.data.permissions.map(p => p._id);

            setCheckedList(defaultValues);
            form.setFieldsValue({
                role_name : rolePermission?.data?.name,
                permissionIds : defaultValues
            })
        }
    }, [rolePermission, form])
    const onSubmit = async (values) => {
        setButtonLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            let data = {
                ...values,
                id
            }
            const resultAction = await dispatch(updateRoleWithPermissions(data))
            if (updateRoleWithPermissions.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Role permission updated successfully');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage("")
                }, 4000)
                if (socketRef.current?.connected) {
                    console.log(data);
                    socketRef.current.emit("role updated", {
                        senderId : user?._id,
                        roleId: data.id,
                        // receiverId : data?.id,
                        permissions: data.permissionIds,
                    });
                }
            } else {
                console.log(resultAction)
                setAlertMessage(resultAction?.payload?.error || 'Error creating role permission');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error creating role permission');
            setAlertType('error');
        } finally {
            setButtonLoading(false);
        }
    }
    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Role</h1>
            <Card title="Edit Role" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                >
                    <Form.Item
                        label="Role Name"
                        name="role_name"
                        rules={[{ required: true, message: 'Please input role name!' }]}
                    >
                        <Input placeholder="Enter role name" />
                    </Form.Item>
                    <Form.Item
                        label="Permissions"
                        name="permissionIds"
                        rules={[{ required: true, message: 'Please select permission!' }]}
                    >
                        {groupedPermissions && 
                            Object.keys(groupedPermissions).map((type) => (
                                <div key={type} style={{ marginBottom: 16 }}>
                                    <h3 style={{ textTransform: "capitalize" }}>
                                        {type}
                                    </h3>

                                    <Checkbox.Group
                                        options={groupedPermissions[type]}
                                        value={checkedList.filter(val =>
                                            groupedPermissions[type].some(p => p.value === val)
                                        )}
                                        onChange={(list) => {
                                            const otherValues = checkedList.filter(
                                                (val) => !groupedPermissions[type].some(p => p.value === val)
                                            );

                                            const newList = [...otherValues, ...list];

                                            setCheckedList(newList);
                                            form.setFieldsValue({ permissionIds: newList });
                                        }}
                                    />
                                </div>
                            ))
                        }
                    </Form.Item>
                    <Form.Item>
                        <Button
                        type="primary"
                        htmlType="submit"
                        loading={buttonLoading}
                        style={{ marginTop: 16 }}
                        >
                        Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
}

export default EditRole